class ListenersService {
    constructor() {
        this.registredListeners = [];
    }
    registerListener(listener) {
        listener.element.addEventListener(listener.type, listener.listener, listener.options);
        this.registredListeners.push(listener);
    }
    removeListener(listener) {
        listener.element.removeEventListener(listener.type, listener.listener, listener.options);
    }
    removeAllListeners() {
        this.registredListeners.forEach((listener) => {
            this.removeListener(listener);
        });
    }
}
export const listenersService = new ListenersService();
